var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 136C105.555 136 136 105.555 136 68C136 60.1133 134.657 52.5401 132.188 45.4967L45.4967 132.188C52.5401 134.657 60.1133 136 68 136ZM13.0509 108.065L46.416 74.7003L7.89132 36.1756C2.85364 45.6708 0 56.5022 0 68C0 82.9801 4.84392 96.8289 13.0509 108.065ZM36.1756 7.89132L74.7003 46.416L108.065 13.0509C96.8289 4.84392 82.9801 0 68 0C56.5022 0 45.6708 2.85364 36.1756 7.89132Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4143 22.5858L30.8285 31",
    stroke: "currentColor",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4143 109L32.0001 117.414",
    stroke: "currentColor",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4143 93L47.0001 101.414",
    stroke: "currentColor",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4143 77L62.0001 85.4142",
    stroke: "currentColor",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.414 45L92.0001 53.4142",
    stroke: "currentColor",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.414 29L107 37.4142",
    stroke: "currentColor",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38L46.4142 46.4142",
    stroke: "currentColor",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55 55L63.4142 63.4142",
    stroke: "currentColor",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4141 61L76.9998 69.4142",
    stroke: "currentColor",
    strokeWidth: 4
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2ca64306f3045cb1c02cadef5a07d7d1.svg";
export { ForwardRef as ReactComponent };